import * as React from "react";
import { Link } from "react-router-dom";
import MailboxStore from "../../../../stores/MailboxStore";
import { GetMailboxList } from "../../../../actions/MailboxActions";
class MailboxSidebar extends React.Component {
  //isList: Array<BPModel>;
  constructor(props) {
    super(props);
    this.state = {
      mailboxList: [],
      iaMailboxList: [],
      smtpMailboxList: [],
      mailboxesLoaded: false
    };
    this.onReceiveMailboxChange = this.onReceiveMailboxChange.bind(this);
  }
  componentDidMount() {
    MailboxStore.addChangeListener(this.onReceiveMailboxChange);
    GetMailboxList();
  }
  componentWillUnmount() {
    MailboxStore.removeChangeListener(this.onReceiveMailboxChange);
  }
  onReceiveMailboxChange() {
    let lastChange = MailboxStore.lastChange();
    if (lastChange === "MailboxList") {
      let mailboxes = MailboxStore.getMailboxes();
      this.setState({
        mailboxList: mailboxes,
        iaMailboxList: mailboxes.filter((i) => i.mailboxType === 11),
        smtpMailboxList: mailboxes.filter((i) => i.mailboxType === 12),
        mailboxesLoaded: true
      });
    }
  }
  render() {
    let listOfIAMailboxes;
    let listOfSmtpMailboxes;
    if (this.state.iaMailboxList !== void 0 && this.state.iaMailboxList.length > 0) {
      listOfIAMailboxes = this.state.iaMailboxList.map((mailbox) => /* @__PURE__ */ React.createElement("div", { style: { marginBottom: "2px" }, key: mailbox.mailboxId }, /* @__PURE__ */ React.createElement(
        Link,
        {
          className: "sidebar-link",
          to: "/Admin/MailboxView/" + mailbox.mailboxId,
          style: { cursor: "Pointer", wordWrap: "break-word" }
        },
        /* @__PURE__ */ React.createElement(
          "i",
          {
            style: { color: "#86AFC0" },
            className: "fa-solid fa-envelope-square"
          }
        ),
        " ",
        mailbox.name
      )));
    } else {
      listOfIAMailboxes = /* @__PURE__ */ React.createElement("div", { style: { fontSize: "10pt", color: "#B2B2B2" } }, "No IA mailboxes");
    }
    if (this.state.smtpMailboxList !== void 0 && this.state.smtpMailboxList.length > 0) {
      listOfSmtpMailboxes = this.state.smtpMailboxList.map((mailbox) => /* @__PURE__ */ React.createElement("div", { style: { marginBottom: "8px" }, key: mailbox.mailboxId }, /* @__PURE__ */ React.createElement(
        Link,
        {
          className: "sidebar-link",
          to: "/Admin/MailboxView/" + mailbox.mailboxId,
          style: { cursor: "Pointer", wordWrap: "break-word" }
        },
        /* @__PURE__ */ React.createElement(
          "i",
          {
            style: { color: "#BCA5D0" },
            className: "fa-solid fa-envelope-square"
          }
        ),
        " ",
        mailbox.name
      )));
    } else {
      listOfSmtpMailboxes = /* @__PURE__ */ React.createElement("div", { style: { fontSize: "10pt", color: "#B2B2B2" } }, "No SMTP mailboxes");
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column p-3 text-white bg-dark",
        style: { height: "100%", width: "245px" }
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: "/Admin/Mailbox",
          className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        },
        /* @__PURE__ */ React.createElement("span", { className: "fs-4" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-envelope-square" }), "   ", "Mailboxes")
      ),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "coolScroll",
          style: { maxHeight: "50%", overflow: "auto" }
        },
        /* @__PURE__ */ React.createElement("div", null, "InboundAutomation"),
        /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "8px" } }, listOfIAMailboxes),
        /* @__PURE__ */ React.createElement("div", { className: "mt-3" }, "Notifications"),
        /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "8px" } }, listOfSmtpMailboxes)
      ),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement(Link, { className: "sidebar-link", to: "/Admin/MailboxView/0" }, "New Mailbox")
    );
  }
}
export default MailboxSidebar;
